import { useMutation, useQueryClient } from "@tanstack/react-query";
import { testingAxios, testingAuthHeaders } from "@/services/testing";
import { planEndpoint } from "@/services/testing";
import type { TestPlan } from "@/services/testing";

/**
 * `status` is deliberately not patchable here: run state is owned by the server. `/execute` validates
 * the stored execution contract at run time, so there is no client-side status to set.
 */
interface UpdatePlanVariables {
  planId: string;
  patch: Partial<Pick<TestPlan, "name" | "intent" | "steps">> & {
    status?: Exclude<TestPlan["status"], "approved">;
  };
}

async function updatePlan({ planId, patch }: UpdatePlanVariables): Promise<TestPlan> {
  const r = await testingAxios.put<TestPlan>(planEndpoint(planId), patch, {
    headers: testingAuthHeaders(),
  });
  return r.data;
}

export function useUpdatePlan() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePlan,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ["testingPlan", variables.planId] });
      void queryClient.invalidateQueries({ queryKey: ["testingPlans"] });
    },
  });
}
